import prettyFormat from './output-formats/pretty-output.js';
import { prettifyJson } from './validation-helpers.js';
const formatters = new Map([
    ['json', (outcome) => prettifyJson(outcome)],
    ['pretty', (outcome, options) => prettyFormat(outcome, options)],
]);
/**
 * Registers (or replaces) the formatter for an output format. The root entry point registers
 * `junit`, which depends on a Node-oriented XML builder; the browser entry ships json + pretty.
 */
export function registerOutputFormatter(format, formatter) {
    formatters.set(format, formatter);
}
export function formatOutput(validationOutcome, format, options) {
    const formatter = formatters.get(format);
    if (!formatter) {
        throw new Error(`Output format '${format}' is not available in this environment. Available: ${[...formatters.keys()].join(', ')}`);
    }
    return formatter(validationOutcome, options);
}
//# sourceMappingURL=format-output.js.map